function uiTextField(index, question) {
    return {
        id: 'question' + index,
        component: 'magic-ui-text',
        isDataField: false,
        properties: {
            content: question,
            style: 'font-weight: 700; color: #000; margin-bottom: 16px',
        },
    };
}

export { uiTextField };
